import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { MUTATION_KEY } from './keys';
import { clmUserCoreApiClient } from '../clients';
import type {
  ApiErrorResponse,
  PatientCreateResponse,
  PatientSettingsUpdateRequest,
} from '../types';
import { isApiErrorResponse } from '../utils';

const patientSettingsUpdateMutation = async ({
  id,
  ...data
}: PatientSettingsUpdateRequest & {
  id: string;
}): Promise<void> => {
  const response = await clmUserCoreApiClient.put<
    PatientCreateResponse,
    ApiErrorResponse
  >(`patient/${id}/settings`, data);
  // its not returning data at the moment
  // TODO revise with cloud team
  // if (!response.data) {
  //   throw new Error('No data returned from update patient settings');
  // }

  if (!response.ok) {
    if (isApiErrorResponse(response.data)) {
      throw new Error(response.data.details);
    }
    throw new Error('Unknown error');
  }
};

export const usePatientUpdateSettingsMutation = (
  config?: Omit<
    UseMutationOptions<void, Error, PatientSettingsUpdateRequest>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    mutationKey: [MUTATION_KEY.PATIENT_SETTINGS_UPDATE],
    mutationFn: patientSettingsUpdateMutation,
    ...config,
  });
